import React, { useEffect } from 'react';
import ModalMain from './ModalMain';
import AdjustProductPriceForm from './AdjustProductPriceForm';
import CreateNewCoupon from './CreateNewCoupon/CreateNewCoupon.Form';
import ReactivateCoupon from './ReactivateCoupon/ReactivateCoupon.Form';
import CreateBundleOffer from './CreateBundleOffer/CreateBundleOffer.Form';
import { useDispatch, useSelector } from 'react-redux';
import { setCouponsList, setInventoryProducts } from '../../../../Features/dropTrackActionSlice';
import { getInactiveCoupons, getInventoryProducts } from '../../../../lib/utils/apiCalls';

function Modal() {
    const dispatch = useDispatch();
    const modalType = useSelector((state) => state.dropTrackProducts.modalType);

    useEffect(() => {
        const handleCouponRequest = async () => {
            try {
                const response = await getInactiveCoupons();
                dispatch(setCouponsList(response));
            }
            catch (err) {
                console.log('Error occurred:', err);
            }
        };

        const handleProductsRequest = async () => {
            try {
                const response = await getInventoryProducts();
                dispatch(setInventoryProducts(response));
            }
            catch (err) {
                console.log('Error occurred:', err);
            }
        };
    
        handleCouponRequest();
        handleProductsRequest();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="fixed z-50 w-full h-full top-0 left-0 bg-[#00000080] flex justify-center items-center">
            {modalType === '' && <ModalMain />}

            {modalType === 'adjust-price' && <AdjustProductPriceForm />}

            {modalType === 'create-coupon' && <CreateNewCoupon />}

            {modalType === 'create-bundle-offer' && <CreateBundleOffer />}

            {modalType === 'activate-coupon' && <ReactivateCoupon />}
        </div>
    );
}

export default Modal;
